import { db } from "@/firebase";

export const handleGetChartData = async (payload, callback) => {
  try {
    await db
      .ref("chartData")
      .child(payload)
      .orderByChild("TimeUnix")
      .once("value", function(snapshot) {
        const chartArray = new Array();

        snapshot.forEach((element) => {
          const chartData = {
            id: snapshot.key,
            ...element.val(),
          };
          chartArray.push(chartData);
        });

        callback(chartArray);
      });
  } catch {
    console.error("Error");
  }
};
